module.exports = __webpack_public_path__ + "static/media/chevron-down.e1cdf79c.svg";